export default {"src":"/_next/static/media/Open Stack.80328d26.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};